import {
  HeroSection,
  ProblemSection,
  SolutionSection,
  FeaturesSection,
  PricingSection,
  AboutSection,
} from '@bq/web-sections';

export interface LandingPageProps {
  onSignUp?: () => void;
}

export function LandingPage({ onSignUp }: LandingPageProps) {
  return (
    <main data-crd-id="r5.bq-landing-page" data-crd-layer="r5">
      <HeroSection onSignUp={onSignUp} />
      <ProblemSection />
      <SolutionSection />
      <FeaturesSection />
      <PricingSection onSignUp={onSignUp} />
      <AboutSection />
    </main>
  );
}
